import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cfp-login-loading-spinner',
  templateUrl: './login-loading-spinner.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginLoadingSpinner {
  protected readonly loading = input<boolean>();
}
